var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 40,
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6264 0H0V40H53.6264V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.695 4.55033V27.2152C23.6916 30.4929 22.388 33.6354 20.0704 35.9531C17.7527 38.2708 14.6102 39.5744 11.3324 39.5778C10.7859 39.5778 10.2619 39.3607 9.87547 38.9743C9.48905 38.5879 9.272 38.0638 9.272 37.5174C9.272 36.9709 9.48905 36.4468 9.87547 36.0604C10.2619 35.674 10.7859 35.4569 11.3324 35.4569C13.5183 35.4569 15.6146 34.5886 17.1602 33.0429C18.7058 31.4973 19.5742 29.401 19.5742 27.2152V25.1547H4.12088C3.02796 25.1547 1.97979 24.7206 1.20698 23.9477C0.434163 23.1749 0 22.1268 0 21.0339V4.55033C0 3.4574 0.434163 2.40924 1.20698 1.63642C1.97979 0.863605 3.02796 0.429443 4.12088 0.429443H19.5742C20.6671 0.429443 21.7153 0.863605 22.4881 1.63642C23.2609 2.40924 23.695 3.4574 23.695 4.55033ZM49.4505 0.429443H33.9973C32.9043 0.429443 31.8562 0.863605 31.0833 1.63642C30.3105 2.40924 29.8764 3.4574 29.8764 4.55033V21.0339C29.8764 22.1268 30.3105 23.1749 31.0833 23.9477C31.8562 24.7206 32.9043 25.1547 33.9973 25.1547H49.4505V27.2152C49.4505 29.401 48.5824 31.4973 47.0365 33.0429C45.491 34.5886 43.3946 35.4569 41.2088 35.4569C40.6623 35.4569 40.1382 35.674 39.7518 36.0604C39.3655 36.4468 39.1484 36.9709 39.1484 37.5174C39.1484 38.0638 39.3655 38.5879 39.7518 38.9743C40.1382 39.3607 40.6623 39.5778 41.2088 39.5778C44.4866 39.5744 47.629 38.2708 49.9468 35.9531C52.2646 33.6354 53.5679 30.4929 53.5714 27.2152V4.55033C53.5714 3.4574 53.1371 2.40924 52.3644 1.63642C51.5916 0.863605 50.5433 0.429443 49.4505 0.429443Z",
    fill: "#45B14A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.6264,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote2);
export default __webpack_public_path__ + "static/media/quote-2.684c8f910af358c1e1e25187054be695.svg";
export { ForwardRef as ReactComponent };